import { CustomerServiceProfile } from "../CustomerServiceProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCustomerServiceProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: CustomerServiceProfile;
    panelHeader: Panel;
    sourceCsmProfile: DataSource;
}
